/*
 * Sticky Add-to-Cart (Dawn 15.1)
 * Spiegelt den echten <product-form>-ATC und proxyt Klicks auf ihn.
 * Verändert keine Core-Dateien. Namespaced Klassen, keine Duplicate-IDs.
 */
if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyATC extends HTMLElement {
      connectedCallback() {
        this.stickyButton = this.querySelector('.sticky-atc__button');
        this.stickyPrice = this.querySelector('.sticky-atc__price');
        this.stickyLabel = this.stickyButton?.querySelector('span');

        // Proxy-Klick einmalig verdrahten
        this.stickyButton?.addEventListener('click', () => {
          if (this.realButton && !this.realButton.hasAttribute('disabled')) {
            this.realButton.click();
          }
        });

        this.bind();

        // Nach Produkt-Swap (handleSwapProduct publisht KEIN variantChange und
        // ersetzt ggf. das gesamte product-info-Element) neu binden.
        this._onProductInfoLoaded = () => this.bind();
        document.addEventListener('product-info:loaded', this._onProductInfoLoaded);

        // Variantenwechsel: Preis + Button-Zustand aus dem Live-DOM spiegeln.
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this._variantUnsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, () => this.mirror());
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this._variantUnsubscribe?.();
        document.removeEventListener('product-info:loaded', this._onProductInfoLoaded);
      }

      /* Referenzen auf das echte Produkt-Formular (neu) beschaffen */
      bind() {
        this.productInfo = document.querySelector('product-info[id^="MainProduct"]');
        if (!this.productInfo) return;

        // Nur das ATC-Formular ist von <product-form> umschlossen –
        // das Installment-Formular (product-form-installment-*) NICHT.
        this.realButton = this.productInfo.querySelector(
          'product-form .product-form__submit[name="add"]'
        );
        this.realPrice = this.productInfo.querySelector('[id^="price-"]');
        const observeEl = this.productInfo.querySelector('product-form .product-form__buttons');

        // Sichtbarkeit: nur zeigen, wenn der echte ATC OBERHALB des Viewports
        // liegt (also daran vorbeigescrollt). !isIntersecting allein wäre auch
        // wahr, wenn der Button noch UNTERHALB (Nutzer oben) ist.
        this.observer?.disconnect();
        if (observeEl && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            ([entry]) => {
              const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              this.classList.toggle('is-visible', scrolledPast);
            },
            { threshold: 0 }
          );
          this.observer.observe(observeEl);
        }

        this.mirror();
      }

      /* Preis + Button-Zustand/Label vom echten ATC spiegeln */
      mirror() {
        if (!this.realButton || !this.realButton.isConnected) {
          this.realButton = this.productInfo?.querySelector(
            'product-form .product-form__submit[name="add"]'
          );
        }
        if (!this.realButton) return;

        if (this.stickyPrice) {
          if (!this.realPrice || !this.realPrice.isConnected) {
            this.realPrice = this.productInfo?.querySelector('[id^="price-"]');
          }
          if (this.realPrice) this.stickyPrice.innerHTML = this.realPrice.innerHTML;
        }

        const disabled = this.realButton.hasAttribute('disabled');
        this.stickyButton.toggleAttribute('disabled', disabled);

        const label = this.realButton.querySelector('span')?.textContent?.trim();
        if (label && this.stickyLabel) this.stickyLabel.textContent = label;
      }
    }
  );
}
